import { Component, Input } from '@angular/core';
import { EventService } from '../../services/event.service';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { IncrementDirective } from '../../directives/increment.directive';
import { DatePipe, NgStyle } from '@angular/common';
import { Event } from '../../models/event.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-progress-event',
  standalone: true,
  imports: [TranslateModule, DatePipe, NgStyle, IncrementDirective],
  templateUrl: './progress-event-widget.component.html',
  styleUrl: '../event-widget/event-widget.component.scss',
})
export class ProgressEventComponent {

  @Input() event: Event | null = null;
  loading:boolean = true;
  error:number | null = null;
  constructor(
    private eventService: EventService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const eventId: string | null = this.route.snapshot.paramMap.get('eventId');

    if (!eventId) {
      console.error(`Erreur avec l'id d'event : ${eventId}.`);
      return;
    }

    this.eventService.getEvent(eventId).subscribe({
      next: (event:Event) => {
        this.event = event;
      },
      error: (err:HttpErrorResponse) => {
          this.loading = false;
          this.error = err.status;            
      },

      complete: () => {
        this.loading = false;
      },
    })
  
  }
}
